/**
 * Main nav dropdown: click to toggle, close on outside click and Escape.
 * Hover to open is handled by CSS.
 */
export function initNavDropdown() {
  const containers = document.querySelectorAll("[data-dropdown]");
  const triggers = document.querySelectorAll("[data-dropdown-trigger]");

  function closeAll() {
    containers.forEach((container) => {
      const dropdown = container.querySelector(".site-header__dropdown");
      const trigger = container.querySelector("[data-dropdown-trigger]");
      container.classList.remove("is-open");
      if (dropdown) dropdown.setAttribute("aria-hidden", "true");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
  }

  function open(container) {
    const dropdown = container.querySelector(".site-header__dropdown");
    const trigger = container.querySelector("[data-dropdown-trigger]");
    container.classList.add("is-open");
    if (dropdown) dropdown.setAttribute("aria-hidden", "false");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
  }

  function toggle(container) {
    const isOpen = container.classList.contains("is-open");
    closeAll();
    if (!isOpen) open(container);
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const container = trigger.closest("[data-dropdown]");
      if (container) toggle(container);
    });
  });

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-dropdown]")) return;
    closeAll();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });
}
